export default "/survey_assets/icons/back.27670531b99b919b38d38b3960400707.svg";